<div class="container">
  <div class="header-row">
    <span>
      <p class="left-section">Game Schedules</p>
    </span>

    <span class="right-section">
      <select [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)">
        <option *ngFor="let year of years" [ngValue]="year">
          {{ year }}
        </option>
      </select>
      <select [(ngModel)]="selectedMarket" (ngModelChange)="onMarketChange($event)">
        <option value="">All Markets</option>
        <option *ngFor="let market of markets" [value]="market">
          {{ market }}
        </option>
      </select>

      <select [(ngModel)]="selectedTeam" (ngModelChange)="onTeamChange($event)">
        <option value="">All Teams</option>
        <option *ngFor="let team of teams" [value]="team">
          {{ team }}
        </option>
      </select>
    </span>
  </div>
  <nz-table
    #basicTable
    [nzData]="matchSchedules"
    [nzLoading]="loading"
    [nzFrontPagination]="true"
    nzTableLayout="fixed"
    nzBordered
    [nzPageSize]="10"
    [nzScroll]="{ x: '98.75rem' }"
    nzNoResult="No game schedules available"
  >
    <thead>
      <tr>
        <th>Matchup</th>
        <th nzShowSort [nzSortFn]="sortByDate" [nzSortDirections]="['ascend', 'descend', null]">Scheduled On</th>
        <th>Location</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let match of basicTable.data">
        <td>
          <div class="matchup">
            <div class="team-left">
              <img
                [src]="'assets/images/club_icons/' + match.team_1_code + '.png'"
                [alt]="match.team_1 + ' logo'"
                class="team-logo"
              />
              <span>{{ match.team_1 }}</span>
            </div>

            <div class="vs">vs</div>

            <div class="team-right">
              <img
                [src]="'assets/images/club_icons/' + match.team_2_code + '.png'"
                [alt]="match.team_2 + ' logo'"
                class="team-logo"
              />
              <span>{{ match.team_2 }}</span>
            </div>
          </div>
        </td>

        <td>{{ match.match_date | date: 'MMMM d, y' }}</td>
        <td>{{ match.location }}</td>
      </tr>

      <ng-template #noData>
        <nz-empty nzNotFoundContent="No game schedules available"></nz-empty>
      </ng-template>
    </tbody>
  </nz-table>
</div>
